<template>
  <div v-if="showOptions.component" class="wrapper">
    <img
      src="@/assets/images/account-connection.png"
      class="asset-image"
      alt="Macha Zendesk connection"
    />
    <div class="info-wrapper">
      <h3>Connect Zendesk to Macha</h3>
      <p>
        Get started by connecting to Macha via oAuth to get access to Macha in a
        few seconds.
      </p>
      <div class="btn-wrapper">
        <button type="button" class="btn btn-primary btn-small">
          Connect account
        </button>
        <span
          >Facing trouble connecting?<br />Reach out to us at
          <a href="mailto:support@getmacha.com">support@getmacha.com</a></span
        >
      </div>
    </div>
  </div>
  <PageLoader v-else :showLoader="true" class="loader"></PageLoader>
</template>
    
<script>
// Components
import PageLoader from "@/components/loaders/PageLoader";

export default {
  name: "ZendeskConnection",
  data() {
    return {
      showOptions: {
        component: false,
      },
    };
  },
  components: { PageLoader },
  async created() {
    await this.checkAccess();
  },
  methods: {
    async checkAccess() {
      if ((await this.authenticateUser()) && this.isZendeskConnected()) {
        this.$store.commit("updateRedirectRoute", "");

        this.$router.push({ path: `/` });
      }
      this.showOptions.component = true;
    },
  },
};
</script>
    
<style scoped lang="scss">
.asset-image {
  display: block;
  width: 10rem;
  margin: 0 auto 2rem;
}

.wrapper {
  margin-top: 3rem;
  flex-direction: row;
  text-align: center;
}

.info-wrapper {
  h3 {
    font-size: $largeFontSize;
  }
  p {
    font-size: $smallFontSize;
    color: $greyColor;
  }
}

.btn-wrapper {
  .btn {
    margin: 2rem auto 1rem;
  }

  span {
    display: block;
    color: lighten($greyColor, 15%);
    font-size: $smallerFontSize;
  }
}

.loader {
  margin-top: 4rem;
}
</style>